/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import ApiConstants from "bundle/constants/ApiConstants";
import searchApi from "app/api/SearchApi";
import SearchAPICommands from "common/constants/SearchAPICommands";
import { commandError } from "bundle/util/ErrorUtils";

export default class SearchCommands {
    constructor() {
        this._apiCommands = {
            [SearchAPICommands.ON_RESULTS_UPDATE]: { action: this._onResultsUpdate },
            [SearchAPICommands.NEXT]: { action: this._next },
            [SearchAPICommands.PREVIOUS]: { action: this._previous },
            [SearchAPICommands.CLEAR]: { action: this._clear },
        };
    }

    static getClassName() {
        return "SearchCommands";
    }

    executeCommand = data => {
        const { searchId } = data.commandData;
        if (searchApi.getCurrentSearchId() === searchId) {
            return Promise.resolve(this._apiCommands[data.command].action());
        }
        return Promise.reject(commandError(ApiConstants.API_RESPONSE.FAIL, "Search session does not match."));
    }

    _onResultsUpdate = () => searchApi.onResultsUpdate();

    _next = () => searchApi.next();

    _previous = () => searchApi.previous();

    _clear = () => searchApi.clear();
}
